import $$ from 'cmn-utils'

const baseUrl = "/api/safety/position/";
export default {
    create: (params) => {
        params.templateIdList = params.templateList && params.templateList.map(item => item.id) || []
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        params.templateIdList = params.templateList && params.templateList.map(item => item.id) || []
        return $$.post(baseUrl + 'update', params)
    },
}